export const SIZE_TO_STYLE = {
  large: {
    fontSize: "24px",
    height: "48px"
  },
  medium: {
    fontSize: "14px",
    height: "32px"
  },
  "medium-large": {
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "24px"
  }
};
